import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="w-full py-20 md:py-28 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-14">
          <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-accent-100 text-accent-700 mb-4">
            软件分类
          </span>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-900 mb-4">
            八大分类，精准导航
          </h2>
          <p className="text-foreground-600 max-w-2xl mx-auto text-base">
            按照使用场景精心分类，无论你需要什么类型的软件，都能在这里快速找到。
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {categories.map((category) => (
            <Link
              key={category.slug}
              to={`/category/${category.slug}`}
              className="group p-6 rounded-lg bg-white border border-background-200/70 hover:border-primary-300 hover:shadow-sm transition-all duration-300 cursor-pointer"
            >
              <div className="w-11 h-11 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 mb-4 group-hover:bg-accent-500 group-hover:text-white transition-colors duration-300">
                <i className={`${category.icon} text-lg`} />
              </div>
              <h3 className="text-base font-semibold text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors duration-200">
                {category.name}
              </h3>
              <p className="text-xs text-foreground-500 mb-3 leading-relaxed line-clamp-2">
                {category.description}
              </p>
              <span className="text-xs font-medium text-primary-500">
                {category.softwareCount} 款软件 &rarr;
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}